export default __webpack_public_path__ + "static/media/home3.f1eb23e0.jpg";